module.exports = __webpack_public_path__ + "static/img/104020.db57d157.png";